module.exports = __webpack_public_path__ + "img/frontpage-featured-image-6.31539774.webp";